import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../../components/AppIcon';

const SuccessAnimation = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-success-50 to-primary-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, type: "spring", stiffness: 200 }}
        className="text-center"
      >
        {/* Success Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, duration: 0.3, type: "spring", stiffness: 300 }}
          className="inline-flex items-center justify-center w-24 h-24 bg-success text-white rounded-full mb-6"
        >
          <Icon name="CheckCircle" size={48} />
        </motion.div>

        {/* Success Message */}
        <motion.h1
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.3 }}
          className="text-3xl font-heading font-bold text-accent-800 mb-4"
        >
          Email Verified!
        </motion.h1>

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.3 }}
          className="text-accent-600 text-lg mb-6"
        >
          Your account has been successfully verified.
        </motion.p>

        {/* Celebration Elements */}
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          className="flex justify-center space-x-4 mb-8"
        >
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-success rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-warning rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </motion.div>

        {/* Redirect Message */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.3 }}
          className="text-accent-500 text-sm"
        >
          <p>Redirecting you to homepage...</p>
          <div className="mt-4 flex justify-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default SuccessAnimation;